export default (str, ...rest) => str
  .replace(/%@(\d+)/g, (match, number) => {
    const idx = number - 1; // our interpolation ids start from 1
    return typeof rest[idx] !== 'undefined'
      ? rest[idx]
      : match;
  });
